// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3g6BZ","signatureButtonsRight":"ModalSign_signatureButtonsRight__15UX5"};